import $http from '@vue-util/http';
import { UOP_ESTIMATED_REFUND_ENDPOINT } from '#shared/endpoints';
import { RETURN_ESTIMATION_ERROR } from '#shared/constants';
import { fireApiErrorTag } from '@/utils/returns/General';
import { createHeaders } from '@/utils/CreateHeaders';
import { errorHandler } from '@/utils/ErrorHandler';
import { useReturnItemStore } from '@/stores/returns/useReturnItemStore';
import { REFUND_METHOD } from 'config';

export const useEstimatedRefundStore = defineStore('estimatedRefundStore', {
  state: () => ({
    estimatedRefund: {
      amountDue: 0,
      totalRefundAmount: 0,
      isWareHouseReturn: false,
    },
    estimatedRefundError: null,
  }),
  getters: {
    IS_EXCHANGE_REFUND_AVAILABLE: (state) => {
      // if (!state.estimatedRefund) return false; // unnecessary guard
      const { EXCHANGE, REPLACEMENT } = REFUND_METHOD;
      const SUBSTITUTE_FIELDS = ['substituteMerchandiseTotal', 'substituteTotalTaxes', 'substituteTotalRefundAmount', 'exchangeCredit', 'amountDue'];
      const choice = useReturnItemStore().returnSelections.refundOption?.choice;
      return [EXCHANGE, REPLACEMENT].includes(choice) && SUBSTITUTE_FIELDS.every((f) => state.estimatedRefund?.[f] !== undefined);
    },
  },
  actions: {
    SET_ESTIMATED_REFUND(estimatedRefund) {
      this.estimatedRefund = estimatedRefund;
    },
    SET_ESTIMATED_REFUND_ERROR(error) {
      this.estimatedRefundError = error;
    },
    async GET_ESTIMATED_REFUND({ payload }) {
      if (this.estimatedRefundError) this.SET_ESTIMATED_REFUND_ERROR(null);

      try {
        const headers = createHeaders();
        const response = await $http.post(UOP_ESTIMATED_REFUND_ENDPOINT, [payload], headers);
        this.SET_ESTIMATED_REFUND(response.data.estimateRefundResponse);
      } catch (error) {
        const { errorCode = '', message = '' } = error?.response?.data?.errors?.error?.[0] ?? {};
        fireApiErrorTag({
          errorCode,
          message: RETURN_ESTIMATION_ERROR,
          miscMessage: message,
          errorLabel: 'get estimated refund',
        });
        this.SET_ESTIMATED_REFUND_ERROR(errorHandler(null, RETURN_ESTIMATION_ERROR));
        throw error;
      }
    },
  },
});
